import request from '@/utils/request'

 // 查询供应商基础产能设置列表
export function apiScpSopBasicCapacityLoadList (query) {
    return request({
        url: `/scp/scpSopBasicCapacityLoad/list`,
        method: 'get',
        params: query
    })
}
